import { DownloadOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import * as XLSX from "xlsx";
import moment from "moment";
import { formatDate } from "utils/dateFormat";
import { useAppSelector } from "store";
import { LoadTaxInvoiceItems } from "services/interface";
import { FC, useState } from "react";
import { useLoadTaxInvoiceData } from "hooks/useOrders";


interface ExportTaxToExcelProps {
  searchInput: string;
  dateStartInput: string
  dateEndInput: string
}

const ExportTaxToExcel : FC<ExportTaxToExcelProps> = ({
  searchInput,
  dateStartInput,
  dateEndInput,
}) => {
  const [loading, setLoading] = useState(false);
  const usrName = useAppSelector((state) => state.auth.profile?.user?.name);

  const factoryId = useAppSelector((state) => state.auth.profile?.user?.role?.ref_id);
  const { data: taxListData } = useLoadTaxInvoiceData({
    search: searchInput,
    factory_id: factoryId ?? '',
    is_active: true,
    start_date: dateStartInput,
    end_date: dateEndInput,
    offset: 0,
    limit: 99999,
  });

  const exportToExcel = async () => {
    setLoading(true);

    try {

      let arr = taxListData?.data.data?.map((item: any, index) => {
        const newData = {
          ลำดับ: index + 1,
          เลขที่คำสั่งซื้อ: item.order_code,
          วันที่สั่งซื้อ: formatDate(item.order_date) || '-',
          วันที่จัดส่ง: formatDate(item.due_date) || '-',
          ชื่อ: item.tax_name,
          หมายเลขประจำตัวผู้เสียภาษี: item.tax_no,
          เบอร์โทรศัพท์: item.telephone,
          ที่อยู่: item.address_text,
        };

        return newData;
      });

       console.log(arr)

      if (arr) {
        let Heading = [
          [
            "ลำดับ",
            "เลขที่คำสั่งซื้อ",
            "วันที่สั่งซื้อ",
            "วันที่จัดส่ง",
            "ชื่อ",
            "หมายเลขประจำตัวผู้เสียภาษี",
            "เบอร์โทรศัพท์",
            "ที่อยู่",
          ],
        ];

        const tableName = `Tax Invoice`;
        const exportDate = `Export Date: ${moment(new Date()).format("DD-MM-YYYY")}`;
        const exportName =  `User: ${usrName}`;

        const wb = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);

        XLSX.utils.sheet_add_aoa(ws, [[tableName]], { origin: "A1" });
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }];
        XLSX.utils.sheet_add_aoa(ws, [[exportName]], { origin: "A2" });
        XLSX.utils.sheet_add_aoa(ws, [[exportDate]], { origin: "A3" });
        XLSX.utils.sheet_add_aoa(ws, Heading,  { origin: "A5" });
        XLSX.utils.sheet_add_json(ws, arr, { origin: "A6", skipHeader: true });

        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        XLSX.writeFile(wb, genfileName());
      } else {
        message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      message.error("ไม่สามารถดาวน์โหลดไฟล์ได้");
      setLoading(false);
      return;
    }

    setLoading(false);
  };

  const genfileName = () => {
    const date = new Date();
    const fileName = `tax_invoice_${moment(date).format(
      "DD-MM-YYYY-HHMMSS"
    )}.xlsx`;
    return fileName;
  };

  return (
    <Button
      type="default"
      style={{ marginRight: 10 }}
      icon={<DownloadOutlined />}
      size="middle"
      loading={loading}
      onClick={exportToExcel}
    >
      ส่งออก Excel
    </Button>
  );
};

export default ExportTaxToExcel;
